const PRODUCT_CATEGORY_ALIASES = {
  all: 'all',
  products: 'all',
  premium: 'premium',
  premiums: 'premium',
  exclusive: 'exclusive',
  exclusives: 'exclusive',
  bundle: 'bundle',
  bundles: 'bundle',
  addon: 'addon',
  addons: 'addon',
  free: 'free',
  'free-script': 'free',
  'free-scripts': 'free',
  freescripts: 'free',
  other: 'other',
  others: 'other',
};

const PAGE_ROUTES = {
  home: '/',
  index: '/',
  shop: '/products',
  products: '/products',
  all: '/products',
  premium: '/products/premium',
  exclusive: '/products/exclusive',
  bundle: '/products/bundle',
  bundles: '/products/bundle',
  addon: '/products/addon',
  addons: '/products/addon',
  free: '/products/free',
  'free-script': '/products/free',
  'free-scripts': '/products/free',
  other: '/products/other',
  others: '/products/other',
  orders: '/orders',
  order: '/orders',
  scripts: '/my-scripts',
  'my-scripts': '/my-scripts',
  myscripts: '/my-scripts',
  profile: '/profile',
  account: '/profile',
  downloads: '/downloads',
  download: '/downloads',
  refer: '/refer-and-earn',
  referral: '/refer-and-earn',
  'refer-and-earn': '/refer-and-earn',
  wishlist: '/wishlist',
  notifications: '/notifications',
  notification: '/notifications',
  auth: '/auth',
  login: '/auth',
  bind: '/auth?redirect=/profile',
  'telegram-bind': '/auth?redirect=/profile',
  signup: '/auth?mode=signup',
  about: '/about',
  contact: '/contact',
  privacy: '/privacy',
  terms: '/terms',
};

const safeDecode = (value = '') => {
  try {
    return decodeURIComponent(String(value).replace(/\+/g, ' '));
  } catch {
    return String(value);
  }
};

const normalizeToken = (value = '') =>
  safeDecode(value).trim().replace(/^\/+|\/+$/g, '').toLowerCase();

const cleanId = (value = '') => safeDecode(value).trim().replace(/^\/+|\/+$/g, '');

export const routeTo = {
  home: () => '/',
  page: (page) => PAGE_ROUTES[normalizeToken(page)] || '/',
  products: (category = 'all') => {
    const normalized = PRODUCT_CATEGORY_ALIASES[normalizeToken(category)] || normalizeToken(category);
    return normalized && normalized !== 'all' ? `/products/${normalized}` : '/products';
  },
  product: (productId) => `/product/${encodeURIComponent(cleanId(productId))}`,
  auth: (refCode) => refCode ? `/auth?ref=${encodeURIComponent(cleanId(refCode))}` : '/auth',
  refer: () => '/refer-and-earn',
};

export const getPageRoute = (page) => routeTo.page(page);

export const getProductRoute = (productId) => routeTo.product(productId);

export const getProductsRoute = (category) => routeTo.products(category);

export const normalizeProductCategory = (category) =>
  PRODUCT_CATEGORY_ALIASES[normalizeToken(category)] || normalizeToken(category) || 'all';

export const resolveInternalRoute = (input) => {
  if (!input) return null;
  const raw = safeDecode(input).trim();
  if (!raw) return null;

  if (raw.startsWith('/')) return raw;

  const [headRaw, ...restParts] = raw.split(/[:_]/);
  const head = normalizeToken(headRaw);
  const rest = cleanId(restParts.join('_'));
  const normalizedWhole = normalizeToken(raw);

  if (head === 'product' || head === 'prod' || head === 'p') {
    return rest ? routeTo.product(rest) : null;
  }

  if (head === 'category' || head === 'cat' || head === 'products') {
    return routeTo.products(rest || 'all');
  }

  if (head === 'page' || head === 'route' || head === 'go') {
    return PAGE_ROUTES[normalizeToken(rest)] || null;
  }

  if (head === 'ref' || head === 'refer') {
    return rest ? routeTo.auth(rest) : routeTo.refer();
  }

  return PAGE_ROUTES[normalizedWhole] || null;
};

export const resolveRouteFromSearch = (search = '') => {
  const params = new URLSearchParams(search);
  return (
    resolveInternalRoute(params.get('route')) ||
    resolveInternalRoute(params.get('to')) ||
    resolveInternalRoute(params.get('page')) ||
    resolveInternalRoute(params.get('startapp')) ||
    resolveInternalRoute(params.get('tgWebAppStartParam'))
  );
};

export const productCategoryAliases = PRODUCT_CATEGORY_ALIASES;
export const pageRoutes = PAGE_ROUTES;
